export const currencies = [
  { index: 1, name: 'EUR', symbol: '€' },
  { index: 2, name: 'GBP', symbol: '£' },
  { index: 3, name: 'USD', symbol: '$' }
];